import React, { FunctionComponent, memo } from 'react'
import styles from './Results.module.sass'
import clsx from 'clsx'
import Image from '../files/Image/Image'
import { FileData } from '../../../responses/files'
import { last } from 'fp-ts/es6/Array'
import { chain, isSome } from 'fp-ts/es6/Option'
import { pipe } from 'fp-ts/es6/function'
import { lineCommentsSelector, taskCommentsSelector } from '../../../utils/selectors'
import { useRootSelector } from '../../../utils/hooks'
import NoImageIcon from '../../../../files/image-empty.svg'
import { useQueries } from '../../../utils/hooks/useQueries'
import equal from 'fast-deep-equal'
import { ID } from '../../../types/UtilityTypes'
import { commentFiles } from '../../../utils/lenses'
import { flatten, map } from 'fp-ts/Array'
import { flow } from 'fp-ts/function'
import SideMark from '../../etc/SideMark/SideMark'
import { Colors } from '../../../styles'
import CenterMark from '../../etc/SidePanel/CenterMark/CenterMark'

type Props = {
    className?: string,
    onClick: (data: FileData) => void,
    showEmpty?: boolean,
} & ({
    mode: 'task',
    taskId: ID,
} | {
    mode: 'line',
    parentId: ID,
})

const Results: FunctionComponent<Props> = props => {
    const selector = props.mode === 'task' ?
        taskCommentsSelector(props.taskId):
        lineCommentsSelector(props.parentId)

    const count = useRootSelector(state => pipe(
        state,
        selector,
        map(commentFiles.get),
        flatten,
    ).length)

    const file = useRootSelector(state => pipe(
        state,
        selector,
        last,
        chain(flow(commentFiles.get, last)),
    ), equal)

    const {isMobile} = useQueries()

    return isSome(file) ? <Image
        className={clsx(props.className, styles.results, styles.interactive)}
        file={file.value}
        onClick={() => props.onClick(file.value)}
    >
        <SideMark color={Colors.green}/>
        <CenterMark>{count}</CenterMark>
    </Image> : (props.showEmpty ?
        <div className={clsx(props.className, styles.results)}>
            <div className={styles.empty}>
                <SideMark color={Colors.green}/>
                {
                    isMobile ? <NoImageIcon/> : <>
                        <NoImageIcon/>
                        <div>Результаты пусты</div>
                    </>
                }
            </div>
        </div> :
        null)
}

Results.whyDidYouRender = true

export default memo(Results)